import axios from 'axios';
import { useEffect, useRef } from 'react';

export function useTokenRefresh(refreshUrl: string, intervalMs: number = 15 * 60 * 1000) {
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const refreshToken = async () => {
            try {
                if (localStorage.getItem("JWT")) {
                    if (localStorage.getItem("JWT") !== "") {
                        const response = await axios.post("https://api2.llavemovil.com/routing/v1/default.aspx",
                            {
                                data: "none"
                            },
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-routing': '/users/user/login',
                                    'JWT': localStorage.getItem("JWT"),
                                }
                            });

                        const data = response.data;
                        if (data) {
                            if (data.JWT && data.JWTRenew !== '') {
                                localStorage.setItem("JWT", data.JWTRenew)
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Token refresh failed:', error);
            }
        };

        // Call immediately once, then periodically
        //refreshToken();
        timerRef.current = setInterval(refreshToken, intervalMs);

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [refreshUrl, intervalMs]);
}